import React, { useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ShimmerTitle } from "react-shimmer-effects";
import {
	getUserAccount,
	getUserState,
	updateState,
} from "../redux/authentication/getUserSlice";
import { logoutAction } from "../redux/authentication/userLoginSlice";

export const Sidebar = () => {
	const location = useLocation();
	const dispatch = useDispatch();

	const logoutHandler = (data) => {
		dispatch(logoutAction());
	};

	const { pathname } = location;

	const splitLocation = pathname.split("/");

	const { userData, activeBusiness, userAccount, isLoading } =
		useSelector(getUserState);

	useEffect(() => {
		if (
			activeBusiness &&
			userData?.activeBusiness?.id !== activeBusiness?.id
		) {
			dispatch(getUserAccount(activeBusiness?.id));
		}
	}, [activeBusiness, dispatch, userData]);

	const businessTogle = () => {
		let businessmenu = document.querySelector(".businessmenu");
		businessmenu.classList.toggle("active");
	};

    const changeBusiness = (data) => {
        dispatch(updateState(data));

        dispatch(getUserAccount(data?.id));

		localStorage.setItem("payvessel-activeBusiness", JSON.stringify(data));
	};

	const closeNav = () => {
		let mainNav = document.querySelector(".sidebar");
		mainNav.classList.remove("sidebar-toggle-active");
	};

	return (
		<div
			className="navbar"
			style={{ top: pathname === "/support" ? 0 : "50px" }}
		>
			<div className="brand-flex">
				<Link
					className="brand"
					to={"/"}
				>
					<img
						src="/images/logo-white.png"
						alt=""
						className="bar-logo"
					/>
				</Link>

				<i
					className="close-icon fas fa-times"
					onClick={closeNav}
				/>
			</div>

			<div className="businessName">
				<div className="activebusiness">
					<div>
						{isLoading ? (
							<>
								<ShimmerTitle
									line={1}
									gap={10}
									variant="primary"
								/>{" "}
							</>
						) : (
							<>
								{" "}
								<span> {activeBusiness?.name}</span>
								<span>
									{userAccount?.data?.account_number} |{" "}
									{userAccount?.data?.bank_name}
								</span>{" "}
							</>
						)}
					</div>

					<i
						className="fas fa-angle-down"
						onClick={businessTogle}
					/>
				</div>

				<div className="businessmenu ">
					<div className="divider"></div>

					<div className="businesslist">
						{userData?.businesses.map(
							(x) =>
								x.name !== activeBusiness?.name && (
									<Fragment key={x.name}>
										<span onClick={() => changeBusiness(x)}>
											{x.name}
										</span>

										<div className="divider"></div>
									</Fragment>
								),
						)}

						<span>
							{" "}
							<Link to="/add-new-business">Add New Business</Link>
						</span>
						<div className="divider"></div>
					</div>
				</div>
			</div>

			<nav className="nav-list">
				<ul className="nav-list-first">
					<li
						className={
							splitLocation[1] === "dashboard" ? "active" : ""
						}
					>
						<Link to="/dashboard">
							<span className="flex-icon">
								<img
									src={"../images/dashboard.png"}
									className="nav-icon"
									alt=""
								/>

								<span className="side-text">Dashboard</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "compliance" ? "active" : ""
						}
					>
						<Link to="/compliance">
							<span className="flex-icon">
								<img
									src={"../images/icons/compliance.png"}
									className="nav-icon"
									alt=""
								/>

								<span className="side-text">Compliance</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "transactions" ? "active" : ""
						}
					>
						<Link to="/transactions">
							<span className="flex-icon">
								<img
									src={"../images/icons/transactions.png"}
									className="nav-icon"
									alt=""
								/>

								<span className="side-text">Transactions</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "withdraw" ? "active" : ""
						}
					>
						<Link to="/withdraw">
							<span className="flex-icon">
								<img
									src={"../images/icons/bank.png"}
									className="nav-icon"
									alt=""
								/>
								<span className="side-text">Withdraw</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "customer-reserved-account"
								? "active"
								: ""
						}
					>
						<Link to="/customer-reserved-account">
							<span className="flex-icon">
								<img
									src={"../images/icons/card.png"}
									className="nav-icon"
									alt=""
								/>

								<span className="side-text">
									{" "}
									Virtual Accounts
								</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "customers" ? "active" : ""
						}
					>
						<Link to="/customers">
							<span className="flex-icon">
								<img
									src={"../images/icons/customers.png"}
									className="nav-icon"
									alt=""
								/>
								<span className="side-text"> Customers</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "webhook-event" ? "active" : ""
						}
					>
						<Link to="/webhook-event">
							<span className="flex-icon">
								<img
									src={"../images/icons/webhook.png"}
									className="nav-icon"
									alt=""
								/>
								<span className="side-text">
									{" "}
									Webhook Events
								</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "settings" ? "active" : ""
						}
					>
						<Link to="/settings">
							<span className="flex-icon">
								<img
									src={"../images/icons/settings.png"}
									className="nav-icon"
									alt=""
								/>

								<span className="side-text"> Settings</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "support" ? "active" : ""
						}
					>
						<Link to="/support">
							<span className="flex-icon">
								<img
									src={"../images/icons/support.png"}
									className="nav-icon"
									alt=""
								/>

								<span className="side-text"> Support</span>
							</span>
						</Link>
					</li>
				</ul>
				<ul className="nav-list-second">
					<li
						className={
							splitLocation[1] === "developer" ? "active" : ""
						}
					>
						<Link
							to="https://payvessel.gitbook.io/payvessel/"
							target="_blank"
						>
							<span className="flex-icon">
								<img
									src="../images/code.png"
									className="nav-icon"
									alt=""
								/>{" "}
								<span className="side-text">
									{" "}
									Documenmtation
								</span>
							</span>
						</Link>
					</li>

					<li
						className={
							splitLocation[1] === "logout" ? "active" : ""
						}
					>
						<Link
							to="#"
							onClick={logoutHandler}
						>
							<span className="flex-icon">
								<img
									src="../images/logout.png"
									className="nav-icon"
									alt=""
								/>{" "}
								<span className="side-text"> Log out</span>
							</span>
						</Link>
					</li>
				</ul>
			</nav>
		</div>
	);
};
